enum DataActions {
  SET_TABLES_EMPTY = '[data] SET_TABLES_EMPTY',
  ADD_QUERY_SYNC_TABS = '[data] Add query sync tabs',
  UPDATE_QUERY_SYNC_TABS = '[data] Update query sync tabs',
  ADD_ASYNC_TABS = '[data] Add async tabs',
  SUBSCRIBE_TO_MAP = '[data] Subscribe too map changes',
  UNSUBSCRIBE_TO_MAP = '[data] Unsubscribe too map changes',
  UPDATE_SELECTIONS = '[data] Update Selections',
  UPDATE_EXPANDED = '[data] Update Expanded',
  CHANGE_PAGE = '[data] Change page',
  SET_TABLE_INFOS = '[data] Set Table Infos',
  SEND_LOADING_TABLES = '[data] Sending loading tables',
  ADD_SYNC_TABS = '[data] Add sync tabs',
  SET_LOADING = '[data] Set all tables loading',
  SET_TABLES_VISIBILITY = '[ui] Set tableS visibility',

  SET_SINGLE_VIEW_SELECTED_FEATURE = '[data] SET_SINGLE_VIEW_SELECTED_FEATURE',
  REMOVE__SINGLE_VIEW_SELECTED_FEATURE = '[data] REMOVE__SINGLE_VIEW_SELECTED_FEATURE',

  SET_SINGLE_CREATE_SELECTED_FEATURE = '[data] SET_SINGLE_CREATE_SELECTED_FEATURE',
  REMOVE_SINGLE_CREATE_SELECTED_FEATURE = '[data] REMOVE_SINGLE_CREATE_SELECTED_FEATURE'
}
export default DataActions
